import Slug from '../Slug';
import { renderValue } from './renderValue';
import { CompositeColumn } from './CompositeColumn';

type ColumnProps = {
  data: Record<string, any>;
  column: DynamicColumnType;
};

export const Column: React.FC<ColumnProps> = ({ data, column }) => {
  if (column.type === 'composite') {
    return <CompositeColumn column={column} data={data} />;
  }

  const value = data?.[column.key];

  if (column.type === 'enum') {
    const style = column.value_styles?.[value] || column.default_style || {};
    const valueLabel = column.value_styles?.[value]?.label || value;
    const label = valueLabel || column.null_label;

    return !!label && <Slug style={style} color={false} text={label} />;
  }

  if (value === null || value === undefined) {
    return column.null_label || '';
  }

  return renderValue(value, column.type);
};

export const renderColumn = (
  data: Record<string, any>,
  column: DynamicColumnType
) => {
  return <Column data={data} column={column} />;
};
